<template>
	<div class="flex_1 margin_horizontal">
		<AccessRestrictedTabs class="table_tabs"
							  v-model="activeTab"
							  :elements="tabTypes"
							  :session-key="$route.path"
		/>
		<ProspectiveReceivableUpload v-if="activeTab === tabTypes.start" @uploaded="updateCounts"/>
		<ProspectiveTable v-if="activeTab === tabTypes.prospective" @changed="updateCounts"/>
		<ProspectiveHistoryTable v-if="activeTab === tabTypes.prospectiveHistory"/>
	</div>
</template>
<script>

import CardList from "@/components/templates/seller/CardList.vue";

import AccessRestrictedTabs from "@/components/templates/common/permissions/AccessRestrictedTabs";
import {enumDef} from "@/common/enumDefs";
import {navigationTabs} from "@/common/navigation/navigationTabs";
import {hasAccess} from "@/common/permission/permission";

import ProspectiveTable from "@/components/templates/seller/prospective/ProspectiveTable.vue";
import {prospectiveReceivableApi} from "@/common/api/prospectiveReceivableApi";
import ProspectiveReceivableUpload from "@/components/templates/seller/prospective/ProspectiveReceivableUpload.vue";
import ProspectiveHistoryTable from "@/components/templates/seller/prospective/ProspectiveHistoryTable.vue";

export default {
	components: {
		ProspectiveHistoryTable,
		ProspectiveReceivableUpload,
		AccessRestrictedTabs,
		CardList,
		ProspectiveTable
	},
	data() {
		let tabTypes = {
			start: {
				name: navigationTabs.seller.marketSounding.start,
				translationKey: "seller.marketSounding.start",
				permission: enumDef.permissions.SellerSellReceivables,
			},
			prospective: {
				name: navigationTabs.seller.marketSounding.prospective,
				translationKey: "seller.marketSounding.prospective",
				permission: enumDef.permissions.SellerSellReceivables,
				count: null
			},
			prospectiveHistory: {
				name: navigationTabs.seller.marketSounding.prospectiveHistory,
				translationKey: "seller.marketSounding.prospectiveHistory",
				permission: enumDef.permissions.SellerSellReceivables,
			}
		};

		return {
			tabTypes: tabTypes,
			activeTab: null,
		};
	},
	created() {
		this.updateCounts();
	},
	beforeDestroy() {
		this.$store.dispatch("setActionLastAddedDebtorResult", null);
	},
	methods: {
		updateCounts() {
			if (hasAccess(this.currentUser, enumDef.permissions.SellerSellReceivables)) {
				prospectiveReceivableApi.inspection.counts()
					.then(counts => {
						this.tabTypes.prospective.count = counts.prospectiveCount;
					});
			}
		},
	}
};
</script>